module.exports = __webpack_public_path__ + "static/img/11.87f1dbf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/travelpolicy/11.jpg
// module id = Libc
// module chunks = 0